import React from 'react';
import PropTypes from 'prop-types';
import { Table, Panel, Label, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import ui from '../../common/services/ui';

const daysOwed = owedSince => moment().startOf('day').diff(moment(owedSince).startOf('day'), 'days');

/**
 * The credit notes raised against this payment - the cancellation credit notes report, narrowed to one payment and
 * without the columns that only repeat what the page already says. Shared by the lesson, workshop and consultation
 * payment pages, and rendered only when there is something to show.
 */
const RefundsPanel = ({ refunds, canSettle, onSettle, t }) => {
	if (!refunds || refunds.length === 0) {
		return null;
	}

	return <Panel>
		<Panel.Heading>{t('PaymentHistory_CancellationCreditNotes')}</Panel.Heading>
		<Panel.Body>
			<Table responsive>
				<thead>
					<tr>
						<th>{t('CancellationCreditNote_CancellationDate')}</th>
						<th>{t('CancellationCreditNote_CancellationReason')}</th>
						<th>{t('CancellationCreditNote_Quantity')}</th>
						<th>{t('CancellationCreditNote_Amount')}</th>
						<th>{t('CancellationCreditNote_Settlement')}</th>
					</tr>
				</thead>
				<tbody>
					{refunds.map(refund => <tr key={refund.id}>
						<td>{ui.formatDateTime(refund.cancellationDate)}</td>
						<td>
							{t(`CancellationReasonType_${refund.cancellationReason}`)}
							{refund.cancellationReason === 'Other' && refund.otherCancellationReason ? `: ${refund.otherCancellationReason}` : ''}
						</td>
						<td>{refund.quantity}</td>
						<td>{ui.formatAmount(refund.amount)}</td>
						<td>
							{refund.settlementStatus && <span className='cell-stack'>
								<Label bsStyle={refund.settlementStatus === 'Owed' ? 'warning' : 'success'}>{t(`RefundSettlementStatus_${refund.settlementStatus}`)}</Label>
								{/* subscription refunds must be paid back within 14 days */}
								{refund.settlementStatus === 'Owed' && refund.owedSince &&
									<div className={refund.hasSettlementDeadline && daysOwed(refund.owedSince) >= 10 ? 'text-danger' : 'text-muted'}>
										{t('CancellationCreditNote_OwedForDays', { count: daysOwed(refund.owedSince) })}
									</div>}
								{refund.settlementStatus === 'Settled' && <div className='text-muted'>
									{ui.formatDate(refund.settledAt)}{refund.settlementReference && ` · ${t('CancellationCreditNote_SettlementReferenceShort')} ${refund.settlementReference}`}
								</div>}
								{refund.settlementStatus === 'Owed' && canSettle &&
									<div><Button bsSize='xsmall' onClick={() => onSettle(refund)}>{t('CancellationCreditNote_MarkAsSettled')}</Button></div>}
							</span>}
						</td>
					</tr>)}
				</tbody>
			</Table>
		</Panel.Body>
	</Panel>;
};

RefundsPanel.propTypes = {
	refunds: PropTypes.array,
	canSettle: PropTypes.bool,
	onSettle: PropTypes.func
};

export default withTranslation()(RefundsPanel);
